import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({
  standalone: true,
  name: 'customCurrency',
})
export class CustomCurrencyPipe extends CurrencyPipe implements PipeTransform {

  
  transform(value: string|number, coverageName?: string): string|null;
  transform(value: null|undefined, coverageName?: string): null;
  transform(value: string|number|null|undefined, coverageName?: string): string|null;

  transform(value: string, coverageName?: string): string {
    let formatedString;
    if (value.indexOf('/') !== -1) {
      const splitValue = value.split('/');
      if (
        coverageName === 'Substitute Transportation (Day/Maximum)' ||
        coverageName === 'Rental Reimbursement (Per Day/Accident)'
      ) {
        formatedString = `${this.toCustomCurrency(
          +splitValue[0]
        )}/${this.toCustomCurrency(+splitValue[1])}`;
      } else {
        formatedString = `${this.toCustomCurrency(
          +splitValue[0] * 1000
        )}/${this.toCustomCurrency(+splitValue[1] * 1000)}`;
      }
    } else if (value === 'Full Coverage') {
      formatedString = value;
    } else {
      formatedString = this.toCustomCurrency(value);
    }
    return formatedString;
  }

  toCustomCurrency(value) {
    return super.transform(
      value.toString().replace(',', ''),
      'USD',
      'symbol',
      '1.0-0'
    );
  }
}
